/** https://docs.tsafe.dev/id  */
const id = (x) => x;

export { id };
//# sourceMappingURL=id.mjs.map
